
export class Country {

  public id: string;
  public name: string;
  public shortCode: string;
  public longCode: string;
  public phoneExtension: string;

  public displayLabel: string;

  static fromDto(d: any): Country {
    if (!d) {
      return null;
    }

    const country = new Country();

    country.id                = d.id;
    country.name              = d.name;
    country.shortCode         = d.short_code;
    country.longCode          = d.long_code;
    country.phoneExtension    = d.phone_extension;

    country.displayLabel = `${country.shortCode} - ${country.name}`;

    return country;
  }

  static toDto(r: Country): any {
    if (!r) {
      return null;
    }

    return {
      id: r.id,
      name: r.name,
      short_code: r.shortCode,
      long_code: r.longCode,
      phone_extension: r.phoneExtension,
    };
  }
}
